var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardRoiTick({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_15872",
    "data-name": "Group 15872",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29.164,
    height: 29.164,
    viewBox: "0 0 29.164 29.164",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8326",
    "data-name": "Rectangle 8326",
    width: 29.164,
    height: 29.164,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15864",
    "data-name": "Group 15864",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5776",
    "data-name": "Path 5776",
    d: "M32.979,19.24A13.74,13.74,0,1,1,19.24,5.5a13.74,13.74,0,0,1,13.74,13.74",
    transform: "translate(-4.658 -4.658)",
    fill: "#62d34e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5777",
    "data-name": "Path 5777",
    d: "M14.582,29.164A14.582,14.582,0,1,1,29.164,14.582,14.6,14.6,0,0,1,14.582,29.164m0-27.479a12.9,12.9,0,1,0,12.9,12.9,12.912,12.912,0,0,0-12.9-12.9",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5778",
    "data-name": "Path 5778",
    d: "M67.16,66.234l-7.735,7.843a.666.666,0,0,1-.965,0l-3.186-3.263a.713.713,0,0,1,0-.98.666.666,0,0,1,.965,0l2.711,2.773,7.261-7.353a.666.666,0,0,1,.965,0,.7.7,0,0,1-.015.98",
    transform: "translate(-46.641 -55.083)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1,
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardRoiTick);
export default __webpack_public_path__ + "static/media/dashboard-roi-tick.b2c1a5f35d5f6832c54eddf0e4afdccb.svg";
export { ForwardRef as ReactComponent };